import React from 'react';
import { Action, Eyebrow, Icon } from './Primitives';
import './UnityFinalCTA.css';
export default function UnityFinalCTA({ onTrial, onDemo, assetBase }) {
  return (
    <section className="ul-final ul-dark" id="start">
      <img
        src={`${assetBase}/knowledge-sculpture.webp`}
        alt=""
        width="1536"
        height="1024"
        loading="lazy"
      />
      <div className="ul-container">
        <div className="ul-final-copy">
          <Eyebrow>The next step is yours</Eyebrow>
          <h2>
            Let your expertise
            <br />
            take someone further.
          </h2>
          <p className="ul-lead">
            Bring one document. Build a programme structure.
            <br />
            Create your first outcome of content.
          </p>
          <div className="ul-actions">
            <Action onClick={onTrial}>Request your free trial</Action>
            <Action secondary onClick={onDemo}>
              Talk through your rollout
            </Action>
          </div>
          <p className="ul-final-reassurance">
            <Icon name="check" size={16} />
            Ask about our 14-day trial · No credit card
          </p>
          <p className="ul-final-scope">
            Our team confirms trial access, AI allowances and support before you start.
          </p>
        </div>
      </div>
    </section>
  );
}
